import { configureStore } from "@reduxjs/toolkit";
import requisitionStateReducer from "./requisitionStateSlice";
import authStateReducer from "./authStateSlice";
import workflowStateReducer from "./workflowStateSlice";
import internalUserStateReducer from "./internalUserStateSlice";
import masterPageStateReducer from "./masterPageStateSlice";

export const store = configureStore({
	reducer: {
		requisitionState: requisitionStateReducer,
		authState: authStateReducer,
		workflowState: workflowStateReducer,
		internalUserState: internalUserStateReducer,
		masterPageState: masterPageStateReducer,
	},
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
